
var drawer = function () {

/**
* Element.closest() polyfill
* https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
*/
if (!Element.prototype.closest) {
    if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    }
    Element.prototype.closest = function (s) {
    var el = this;
    var ancestor = this;
    if (!document.documentElement.contains(el)) return null;
    do {
        if (ancestor.matches(s)) return ancestor;
        ancestor = ancestor.parentElement;
    } while (ancestor !== null);
    return null;
    };
}


// Trap Focus 
// https://hiddedevries.nl/en/blog/2017-01-29-using-javascript-to-trap-focus-in-an-element
//
function trapFocus(element) {
    var focusableEls = element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
    var firstFocusableEl = focusableEls[0];  
    var lastFocusableEl = focusableEls[focusableEls.length - 1];
    var KEYCODE_TAB = 9;

    element.addEventListener('keydown', function(e) {
    var isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);

    if (!isTabPressed) { 
        return; 
    }

    if ( e.shiftKey ) /* shift + tab */ {
        if (document.activeElement === firstFocusableEl) {
        lastFocusableEl.focus();
            e.preventDefault();
        }
        } else /* tab */ {
        if (document.activeElement === lastFocusableEl) {
        firstFocusableEl.focus();
            e.preventDefault();
        }
        }
    });
}       


//
// Settings
//
var settings = {
    speedOpen: 50,
    speedClose: 350,
    activeClass: 'is-active',
    visibleClass: 'is-visible',
    selectorTarget: '[data-drawer-target]',
    selectorTrigger: '[data-drawer-trigger]',
    selectorClose: '[data-drawer-close]',
};


//
// Methods
//

// Toggle accessibility
var toggleAccessibility = function (event) {
    if (event.getAttribute('aria-expanded') === 'true') {
    event.setAttribute('aria-expanded', false);
    } else {
    event.setAttribute('aria-expanded', true);
    }   
};

// Open Drawer
var openDrawer = function (trigger) {

    if(window.SLIDECART) {
      window.SLIDECART_UPDATE();
      window.SLIDECART_OPEN();
    } else {
      // Find target
      var target = document.getElementById(trigger.getAttribute('aria-controls'));
  
      // Make it active
      target.classList.add(settings.activeClass);
  
      // Make body overflow hidden so it's not scrollable
      document.documentElement.style.overflow = 'hidden';
  
      // Toggle accessibility
      toggleAccessibility(trigger);
  
      // Make it visible
      setTimeout(function () {
      target.classList.add(settings.visibleClass);
      trapFocus(target);
      }, settings.speedOpen); 
    }


};

// Close Drawer
var closeDrawer = function (event) {

    if(window.SLIDECART) {
      window.SLIDECART_CLOSE();
    } else {    
      // Find target
      var closestParent = event.closest(settings.selectorTarget),
      childrenTrigger = document.querySelector('[aria-controls="' + closestParent.id + '"');
  
      // Make it not visible
      closestParent.classList.remove(settings.visibleClass);
  
      // Remove body overflow hidden
      document.documentElement.style.overflow = '';
  
      // Toggle accessibility
      toggleAccessibility(childrenTrigger);
  
      // Make it not active
      setTimeout(function () {
      closestParent.classList.remove(settings.activeClass);
      }, settings.speedClose);             
    }


};

// Click Handler
var clickHandler = function (event) {

    // Find elements
    var toggle = event.target,
    open = toggle.closest(settings.selectorTrigger),
    close = toggle.closest(settings.selectorClose);

    // Open drawer when the open button is clicked
    if (open) {
    openDrawer(open);
    }

    // Close drawer when the close button (or overlay area) is clicked
    if (close) {
    closeDrawer(close);
    }

    // Prevent default link behavior
    if (open || close) {
    event.preventDefault();
    }

};

// Keydown Handler, handle Escape button
var keydownHandler = function (event) {

    if (event.key === 'Escape' || event.keyCode === 27) {

    // Find all possible drawers
    var drawers = document.querySelectorAll(settings.selectorTarget),
        i;

    // Find active drawers and close them when escape is clicked
    for (i = 0; i < drawers.length; ++i) {
        if (drawers[i].classList.contains(settings.activeClass)) {
        closeDrawer(drawers[i]);
        }
    }

    }

};


//
// Inits & Event Listeners
//
document.addEventListener('click', clickHandler, false);
document.addEventListener('keydown', keydownHandler, false);

    let reloading = sessionStorage.getItem("reloading");
    if (reloading) {
        sessionStorage.removeItem("reloading");
        const drawer = document.querySelector('#drawer-name');
        drawer.classList.add('is-active','is-visible');
    }

    const emptyContent = document.querySelector('.empty_cart_wrapper');
    const drawerContent = document.querySelector('.cart_items');
    const cartWrapper = document.querySelector('.product_cart_wrapper');
    const totaltWrapper = document.querySelector('.total_cart');

    const emptyCart =  `
    <div class="empty_cart_wr">
        <p class="emty-txt">Your cart is empty</p>
        <a class="cart-continue" href="#" data-drawer-close aria-label="Close Drawer">
            Continue shopping
            <svg class="icon-signpost-arrow " aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="18" height="12" viewBox="0 0 18 12" fill="none">      <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7272 5.6364L10.3636 1.27279L11.6364 0L17.2728 5.6364L11.6364 11.2728L10.3636 10L14.7272 5.6364Z" fill="currentColor"></path>      <path fill-rule="evenodd" clip-rule="evenodd" d="M0 4.73645L16 4.73645L16 6.53645L-1.57361e-07 6.53645L0 4.73645Z" fill="currentColor"></path>    </svg>
        </a>
    </div>
    `;

    let cartTemplate = '';
    let cartTotal = '';




    fetch('/cart.js')
    .then((resp) => resp.json())
    .then((data) => {

        if(window.SLIDECART) {
          window.SLIDECART_UPDATE();
          return;
        }

        if(data.items.length > 0) {

            let totalPrice = (+data.total_price / 100).toFixed(2);
            cartTotal = `
                    <div class="cart-total">
                    <div class="price-row">
                        <div class="cart-title-total">Subtotal</div>
                        <span class="money">$${totalPrice}</span>
                    </div>
                    <div class="shipping-info">Taxes and <a href="/policies/shipping-policy">shipping</a> calculated at checkout</div>
                    <div class="buttons-row">
                        <a href="/cart" class="button-secondary cart-title-button">
                            <svg width="25" height="24" viewBox="0 0 25 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">      <path fill-rule="evenodd" clip-rule="evenodd" d="M1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2H1.33877H1.33883C1.61048 2.00005 2.00378 2.23945 2.10939 2.81599L2.10937 2.816L2.11046 2.82171L5.01743 18.1859C5.12011 18.7286 5.64325 19.0852 6.18591 18.9826C6.21078 18.9779 6.23526 18.9723 6.25933 18.9658C6.28646 18.968 6.31389 18.9692 6.34159 18.9692H18.8179H18.8181C19.0302 18.9691 19.2141 18.9765 19.4075 18.9842L19.4077 18.9842C19.5113 18.9884 19.6175 18.9926 19.7323 18.9959C20.0255 19.0043 20.3767 19.0061 20.7177 18.9406C21.08 18.871 21.4685 18.7189 21.8028 18.3961C22.1291 18.081 22.3266 17.6772 22.4479 17.2384C22.4569 17.2058 22.4642 17.1729 22.4699 17.1396L23.944 8.46865C24.2528 7.20993 23.2684 5.99987 21.9896 6H21.9894H4.74727L4.07666 2.45562L4.07608 2.4525C3.83133 1.12381 2.76159 8.49962e-05 1.33889 0H1.33883H1ZM5.12568 8L6.8227 16.9692H18.8178H18.8179C19.0686 16.9691 19.3257 16.9793 19.5406 16.9877L19.5413 16.9877C19.633 16.9913 19.7171 16.9947 19.7896 16.9967C20.0684 17.0047 20.2307 16.9976 20.3403 16.9766C20.3841 16.9681 20.4059 16.96 20.4151 16.9556C20.4247 16.9443 20.4639 16.8918 20.5077 16.7487L21.9794 8.09186C21.9842 8.06359 21.9902 8.03555 21.9974 8.0078C21.9941 8.00358 21.9908 8.00108 21.989 8H5.12568ZM20.416 16.9552C20.4195 16.9534 20.4208 16.9524 20.4205 16.9523C20.4204 16.9523 20.4199 16.9525 20.4191 16.953L20.416 16.9552ZM10.8666 22.4326C10.8666 23.2982 10.195 24 9.36658 24C8.53815 24 7.86658 23.2982 7.86658 22.4326C7.86658 21.567 8.53815 20.8653 9.36658 20.8653C10.195 20.8653 10.8666 21.567 10.8666 22.4326ZM18.0048 24C18.8332 24 19.5048 23.2982 19.5048 22.4326C19.5048 21.567 18.8332 20.8653 18.0048 20.8653C17.1763 20.8653 16.5048 21.567 16.5048 22.4326C16.5048 23.2982 17.1763 24 18.0048 24Z" fill="currentColor"></path>    </svg>
                            Proceed to Cart
                        </a>
                        <a href="/checkout" class="button-primary cart-title-button">
                            <svg width="25" height="24" viewBox="0 0 25 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">      <path fill-rule="evenodd" clip-rule="evenodd" d="M1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2H1.33877H1.33883C1.61048 2.00005 2.00378 2.23945 2.10939 2.81599L2.10937 2.816L2.11046 2.82171L5.01743 18.1859C5.12011 18.7286 5.64325 19.0852 6.18591 18.9826C6.21078 18.9779 6.23526 18.9723 6.25933 18.9658C6.28646 18.968 6.31389 18.9692 6.34159 18.9692H18.8179H18.8181C19.0302 18.9691 19.2141 18.9765 19.4075 18.9842L19.4077 18.9842C19.5113 18.9884 19.6175 18.9926 19.7323 18.9959C20.0255 19.0043 20.3767 19.0061 20.7177 18.9406C21.08 18.871 21.4685 18.7189 21.8028 18.3961C22.1291 18.081 22.3266 17.6772 22.4479 17.2384C22.4569 17.2058 22.4642 17.1729 22.4699 17.1396L23.944 8.46865C24.2528 7.20993 23.2684 5.99987 21.9896 6H21.9894H4.74727L4.07666 2.45562L4.07608 2.4525C3.83133 1.12381 2.76159 8.49962e-05 1.33889 0H1.33883H1ZM5.12568 8L6.8227 16.9692H18.8178H18.8179C19.0686 16.9691 19.3257 16.9793 19.5406 16.9877L19.5413 16.9877C19.633 16.9913 19.7171 16.9947 19.7896 16.9967C20.0684 17.0047 20.2307 16.9976 20.3403 16.9766C20.3841 16.9681 20.4059 16.96 20.4151 16.9556C20.4247 16.9443 20.4639 16.8918 20.5077 16.7487L21.9794 8.09186C21.9842 8.06359 21.9902 8.03555 21.9974 8.0078C21.9941 8.00358 21.9908 8.00108 21.989 8H5.12568ZM20.416 16.9552C20.4195 16.9534 20.4208 16.9524 20.4205 16.9523C20.4204 16.9523 20.4199 16.9525 20.4191 16.953L20.416 16.9552ZM10.8666 22.4326C10.8666 23.2982 10.195 24 9.36658 24C8.53815 24 7.86658 23.2982 7.86658 22.4326C7.86658 21.567 8.53815 20.8653 9.36658 20.8653C10.195 20.8653 10.8666 21.567 10.8666 22.4326ZM18.0048 24C18.8332 24 19.5048 23.2982 19.5048 22.4326C19.5048 21.567 18.8332 20.8653 18.0048 20.8653C17.1763 20.8653 16.5048 21.567 16.5048 22.4326C16.5048 23.2982 17.1763 24 18.0048 24Z" fill="currentColor"></path>    </svg>
                            Check out
                        </a>
                    </div>
                </div>
            `;


            data.items.forEach(function(product, index) { 
                let price = (+product.final_line_price / 100).toFixed(2);
                cartTemplate += `
                    <div class="drawer-item">
                        <div class="item_media">
                            <img src="${product.featured_image.url}" alt="${product.featured_image.alt}" class="item_img" >
                        </div> 
                        <div class="item_info">
                            <div class="item-title">${product.title}</div>
                            <div class="item-option">${product.variant_options[0]}</div>
                            <div class="item-price"><span>Price: </span>$${price}</div>
                            <div class="item-qty-row">
                                <div class="item-qty-field"><span>Quantity: </span>${product.quantity}</div>
                                <div class="tem-del-icon">
                                    <a
                                        href="/cart/change?line=${index+1}&quantity=0"
                                        class="cart-item--remove-link"
                                        data-cartitem-remove
                                        data-no-instant
                                        aria-label="remove {{ item.product.title | escape }}"
                                    >
                                    <svg aria-hidden="true" focusable="false" role="presentation" width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.08785659,5 L9.77469752,1.31315906 L8.68684094,0.225302476 L5,3.91214341 L1.31315906,0.225302476 L0.225302476,1.31315906 L3.91214341,5 L0.225302476,8.68684094 L1.31315906,9.77469752 L5,6.08785659 L8.68684094,9.77469752 L9.77469752,8.68684094 L6.08785659,5 Z"></path>
                                    </svg>
                                </a>
                                </div>
                            </div>
                        </div> 
                    </div>
                `;


        
            });



            drawerContent.innerHTML = cartTemplate;
            totaltWrapper.innerHTML = cartTotal;
            cartWrapper.classList.remove('hidden');
        } else {
            emptyContent.innerHTML = emptyCart;
            emptyContent.classList.remove('hidden');
        }
    });
};

drawer();
